import React, { useEffect, useCallback } from "react";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const ProductImageModal = ({
  fullScreenImage,
  closeFullScreen,
  productImages,
  currentImageIndex,
  setSelectedImageIndex,
}) => {
  const navigateImage = useCallback(
    (direction) => {
      setSelectedImageIndex((prevIndex) => {
        const newIndex = prevIndex + direction;
        if (newIndex < 0) return productImages.length - 1;
        if (newIndex >= productImages.length) return 0;
        return newIndex;
      });
    },
    [productImages.length, setSelectedImageIndex]
  );

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === "ArrowLeft") {
        navigateImage(-1);
      } else if (e.key === "ArrowRight") {
        navigateImage(1);
      } else  {
        closeFullScreen(e);
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [navigateImage, closeFullScreen]);

  if (!fullScreenImage) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={(e) => closeFullScreen(e)
    }
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/90 p-2 sm:p-4"
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        className="w-full h-full flex items-center justify-center relative"
      >

        <div
          onClick={(e) => e.stopPropagation()}
          onKeyUp={(e) => e.stopPropagation()}
        >
          <button
            type="button"
            onClick={() => navigateImage(-1)}
            className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 text-white bg-white/20 hover:bg-white/30 p-1.5 sm:p-2 rounded-full z-10 transition-all"
          >
            <ChevronLeft className="w-5 h-5 sm:w-6 sm:h-6" />
          </button>

          <img
            src={fullScreenImage}
            alt="Fullscreen Product View"
            className="max-w-full max-h-[85vh] object-contain px-12 sm:px-16"
          />

          <button
            type="button"
            onClick={() => navigateImage(1)}
            className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 text-white bg-white/20 hover:bg-white/30 p-1.5 sm:p-2 rounded-full z-10 transition-all"
          >
            <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6" />
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};
